import { Button } from "@kaltura/ds-react-components";
import { Download24Icon } from "@kaltura/ds-react-icons";
import { ButtonClickAnalyticsType, PlayerAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics, usePlayerAnalytics } from "@kaltura/mediaspace-shared-hooks";

export interface SingleDownloadProps {
    title: string;
    downloadUrl: string;
    analytics?: {
        action: string;
        // Indicates whether to send player analytics event on download click
        shouldSendPlayerAnalytics?: boolean;
        entryId?: string;
    };
}

/**
 * Single Download Component
 */
export const SingleDownload = ({ title, downloadUrl, analytics }: SingleDownloadProps) => {
    const sendButtonAnalytics = useButtonAnalytics();
    const sendPlayerAnalytics = usePlayerAnalytics();

    const sendAnalytics = () => {
        analytics && sendButtonAnalytics(analytics.action, ButtonClickAnalyticsType.DOWNLOAD);
        analytics
            && analytics.shouldSendPlayerAnalytics
            && analytics.entryId
            && sendPlayerAnalytics(PlayerAnalyticsType.DOWNLOAD_CLICKED, analytics.entryId);
    };

    return (
        <Button
            id={"kms-ds-single-download-button"}
            variant={"borderless"}
            startIcon={<Download24Icon />}
            color={"secondary"}
            href={downloadUrl}
            onClick={sendAnalytics}
        >
            {title}
        </Button>
    );
};

export default SingleDownload;
